export enum PatientFormStatusEnum {
    Unknown = 0,
    Sent,
    InProgress,
    SubmitStarted,
    Submitted,
    Approved
}